<template>
  <m-item-wrapper>
    <div
      :class="['nav-sub-heading', '_inner', clickable ? '-clickable':'', clickable ? `-hover-color-${hoverColor}`:'']"
      @click="handleClick"
    >
      <div class="_title">
        {{ title }}
      </div>
    </div>
  </m-item-wrapper>
</template>

<script setup>
import MItemWrapper from 'shared/components/base/MItemWrapper.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  clickable: {
    type: Boolean,
    default: false,
  },
  hoverColor: {
    type: String,
    default: 'regular',
  },
});

const emits = defineEmits(['click']);
const handleClick = (event) => {
  if (!props.clickable) {
    return;
  }
  emits('click', event);
};
</script>

<style scoped lang="scss" type="text/scss">
.nav-sub-heading {
  display: flex;
  align-items: center;
  height: 2.8rem;
  padding: 0 .6rem 0 1rem;
  border-radius: $btn-border-radius;
  transition: background-color .15s ease;

  &.-clickable {
    cursor: pointer;
  }

  &:hover {
    &.-hover-color-beige {
      background-color: $sidebar-hover-color;
    }

    &.-hover-color-regular {
      background-color: $hover-color;
    }
  }

  ._title {
    font-size: $font-size-2;
    font-weight: $font-weight-semibold;
    color: $font-color-secondary;
  }
}
</style>
